// src/context/persona/assist/GeneratingStep.jsx — "Generazione" (v198). The job runs in the BACKGROUND: this step
// only shows its state and says the window can be closed (the page's job card is the way back). When the job
// completes, the persona modal moves to "Revisione" by itself — this component never navigates.
// running → status + the close hint · stale → "interrotto" · failed → our reason + Riprova (only while the caller
// holds the last request). ⛔ Never the server's text: the job's error is worded from its CODE only.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SEMANTIC } from '../../../constants/theme.js';
import { ModalFooter } from '../../../components/ui/WizardModal.jsx';
import { alertBox, choiceHint, footerRow, primaryBtn } from '../personaStyles.js';
import { jobErrorCopy } from './assistCopy.js';

export default function GeneratingStep({ job, view, onRetry }) {
  const { t } = useTranslation('context');
  if (view === 'failed') {
    // A completed job with no proposal is read as failed (edge case) — worded as an internal error, as on JobCard.
    const code = job?.error?.code || (job?.status === 'completed' ? 'INTERNAL_ERROR' : null);
    return (
      <div data-testid="persona-generating-step">
        <div role="alert" style={alertBox(SEMANTIC.errore.fg)}>
          {t('personas.assist.jobFailed', { reason: jobErrorCopy(t, code) })}
        </div>
        {onRetry && (
          <ModalFooter>
            <div style={footerRow}>
              <span style={{ flex: 1 }} />
              <button type="button" onClick={onRetry} style={primaryBtn(false)}>{t('personas.assist.retry')}</button>
            </div>
          </ModalFooter>
        )}
      </div>
    );
  }
  if (view === 'stale') {
    return (
      <div data-testid="persona-generating-step">
        <div role="status" style={alertBox(SEMANTIC.attenzione.fg)}>{t('personas.assist.jobStale')}</div>
      </div>
    );
  }
  return (
    <div data-testid="persona-generating-step">
      <div role="status" style={alertBox(SEMANTIC.info.fg)}>{t('personas.assist.jobRunning')}</div>
      <p style={choiceHint}>{t('personas.wizard.generatingClose')}</p>
    </div>
  );
}
